import { render, staticRenderFns } from "./HomeStaff.vue?vue&type=template&id=32805fda&scoped=true"
import script from "./HomeStaff.vue?vue&type=script&lang=ts"
export * from "./HomeStaff.vue?vue&type=script&lang=ts"
import style0 from "./HomeStaff.vue?vue&type=style&index=0&id=32805fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32805fda",
  null
  
)

export default component.exports